export default "__VITE_ASSET__Ja$yof$P__"